import _extends from '@babel/runtime/helpers/extends';
import React__default, { forwardRef } from 'react';
import cx from 'classnames';
import { node, string, oneOf, bool } from 'prop-types';
import { getIntentClass } from '../../commonClasses.js';

const CARD_PROPS = {
  intent: ['default', 'neutral', 'success', 'warning', 'danger', 'attention']
};
const BASE_CLASS = 'nui-card';
const Classes = {
  BASE: BASE_CLASS,
  NO_BORDER: `${BASE_CLASS}--no-border`,
  SHADOW: `${BASE_CLASS}--shadow`
};
const Card = /*#__PURE__*/forwardRef(({
  children,
  className,
  intent,
  withShadow,
  withBorder = true,
  ...otherProps
}, ref) => {
  const classes = cx(Classes.BASE, getIntentClass(intent), {
    [Classes.SHADOW]: withShadow,
    [Classes.NO_BORDER]: !withBorder
  }, className);
  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: classes
  }, otherProps, {
    ref: ref
  }), children);
});
Card.propTypes = {
  /**
   * content that goes inside card
   */
  children: node.isRequired,
  /**
   * optional custom className
   */
  className: string,
  /**
   * determines the visual appearance
   */
  intent: oneOf(CARD_PROPS.intent),
  /**
   * toggle box shadow visibility
   */
  withShadow: bool,
  /**
   * toggle border visibility
   */
  withBorder: bool
};
Card.defaultProps = {
  intent: 'default',
  withShadow: false
};
Card.displayName = 'NuiCard';
var Card$1 = Card;

export { CARD_PROPS, Classes, Card$1 as default };
